import {TFunction} from "i18next";

export const getRefServiceModeDisplayValue = (
  mode: string,
  t: TFunction<"common"[], undefined, "common"[]>
): string => {
  const props = getIntlProps(mode);
  return t(props.key, props.defaultValue)
};

const getIntlProps = (mode: string): { key: string, defaultValue: string } => {
  switch (mode) {
    case "PLOW":
      return {
        key: "common.entity.refservicemode.plow",
        defaultValue: "Plow"
      }
    case "SALT":
      return {
        key: "common.entity.refservicemode.salt",
        defaultValue: "Salt"
      }
    case "BRINE":
      return {
        key: "common.entity.refservicemode.brine",
        defaultValue: "Brine"
      }
    case "SWEEP":
      return {
        key: "common.entity.refservicemode.sweep",
        defaultValue: "Sweep"
      }
    case "INSPECT":
      return {
        key: "common.entity.refservicemode.inspect",
        defaultValue: "Inspect"
      }
    default:
      return {
        key: "common.entity.refservicemode.unknown",
        defaultValue: "Unknown"
      }
  }
};
